<script>
import { buriedSubmit } from 'common/js/common'
import { BROWSER_TIME } from 'base/config'

const HALFWIDTH = 11

export default {
  name: 'Demonstrat',
  props: {
    insuredAge: {
      type: Number,
      default: 0
    },
    profitType: {
      type: Number,
      default: 0
    },
    propCurYear: {
      type: Number,
      default: 0
    },
    propStartYear: {
      type: Number,
      default: 0
    },
    propProducts: {
      type: Object,
      default () {
        return {
          list: [],
          value: ''
        }
      }
    },
    profit: {
      type: Array
    },
    addAndTake: {
      type: Array,
      default () {
        return []
      }
    },
    insuranceKey: {
      type: Number,
      default: 0
    },
    accountData: {
      type: Object,
      default () {
        return {}
      }
    },
    // 追加领取
    accountBtnsText: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    let { propProducts, profit, propCurYear, propStartYear } = this

    return {
      products: propProducts,
      activeLeft: 0,
      profitList: profit,
      curYear: propCurYear,
      startYear: propStartYear,
      moveDis: 0,
      curType: propProducts.type
    }
  },
  computed: {
    // 当前产品
    curProduct () {
      let {
        products: { list, value }
      } = this
      let result
      if (!list.length) return {}
      list.forEach((pd, index) => {
        if (value === pd.productId) result = pd
      })
      return result
    },
    prdIndex () {
      let {
        products: { list, value }
      } = this
      // 初始产品序列
      let pIdx = -1
      for (var i = 0, j = list.length; i < j; i++) {
        if (list[i].productId === value) {
          pIdx = i
        }
      }
      return pIdx
    },
    // 利益演示长度
    profitLen () {
      let { profitList } = this
      if (!Array.isArray(profitList) || profitList.length < 1) return 0
      let ary = profitList.map(item => {
        return item.values.length
      })
      return profitList[ary.indexOf(Math.max(...ary))].values.length
    },
    // 进度条样式
    barStyle () {
      let maxDis =
        this.moveDis <= this.nSliderWidth ? this.moveDis : this.nSliderWidth
      return {
        width: `${maxDis}px`
        // [preTransition]: this.moveTransition
      }
    },
    // 位移样式
    disStyle () {
      let maxDis =
        this.moveDis <= this.nSliderWidth ? this.moveDis : this.nSliderWidth
      return {
        transform: `translate3d(${maxDis}px, 0, 0)`
        // [preTransition]: this.moveTransition
      }
    },
    // 减保领取
    showAddAndTake () {
      const { addAndTake } = this
      if (!addAndTake || !Array.isArray(addAndTake)) return
      const data = addAndTake[0]
      return (
        data && data.key === 'take' && data.adjustData && data.adjustData.length
      )
    },
    accountPart () {
      const { accountData } = this
      return accountData && accountData.accountPart
    }
  },
  watch: {
    'products.value': {
      handler: function (newVal) {
        this.products.value = newVal
        this.syncDelta &&
          this.syncDelta({ pbData: { interestsCurrentProduct: newVal } })
      }
    },
    'products.type': {
      handler: function (newVal) {
        this.products.type = newVal
        this.syncDelta &&
          this.syncDelta({ pbData: { interestsCurrentType: newVal } })
      }
    },
    'curProduct.bonus.value': {
      handler: function (n, o) {
        if (n && o && n !== o) {
          const {
            curProduct: {
              bonus: { value }
            },
            prdIndex
          } = this
          this.$emit('bonus-change', value, prdIndex)
          this.syncDelta &&
            this.syncDelta({ pbData: { interestsCurrentBonus: value } })
          buriedSubmit('liyi_qh', { name: 'bonus', value })
        }
      }
    },
    'curProduct.rate.value': {
      handler: function (n, o) {
        if (n && o && n !== o) {
          const {
            curProduct: {
              rate: { value }
            },
            prdIndex
          } = this
          this.$emit('rate-change', value, prdIndex)
          this.syncDelta &&
            this.syncDelta({ pbData: { interestsCurrentRate: value } })
          buriedSubmit('liyi_qh', { name: 'rate', value })
        }
      }
    },
    profit: function (newVal) {
      this.profitList = newVal
      // dom更新后刷新 滑动条
      this.$nextTick(() => {
        this._initSlider()
        this._setDisByYear()
      })
    },
    propCurYear(val) {
      this.curYear = val
    },
    curYear (newYear) {
      this.$emit('update-year', newYear)
      this._setDisByYear(newYear)
      this.syncDelta &&
        this.syncDelta({ pbData: { interestsCurrentYear: newYear } })
    },
    curProfit (newData, oldData) {
      this._initSlider()
      this._setDisByYear()
    }
  },
  created () {
    const { list, value } = this.products
    // 初始产品序列
    for (var i = 0, j = list.length; i < j; i++) {
      if (list[i].productId === value) {
        this.pidx = i
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this._initSlider()
      this._setDisByYear()
      // 默认显示追加/领取后
      this.partHandler(1)
    }, BROWSER_TIME)
  },
  methods: {
    // 滑条初始化
    _initSlider () {
      const {
        $refs: { runway },
        profitLen
      } = this
      if (!runway) return

      this.elRunway = runway
      this.offset = runway.offsetLeft
      this.nSliderWidth = parseFloat(getComputedStyle(runway, null).width)
      this.nStep = this.nSliderWidth / (profitLen - 1)
      this.maxIndex = Math.round(this.nSliderWidth / this.nStep)
    },
    /* slider handler */
    startHandler (e) {
      this.bActive = true
      // this.moveTransition = 'none';
      this.nDisX = HALFWIDTH + this.offset
    },
    moveHandler (e) {
      // if (!this.bActive) return
      let touch = e.targetTouches[0]
      let left = touch.pageX - this.nDisX
      this._setDisByWidth(left)
    },
    endHandler (e) {
      this.bActive = false
      // this.moveTransition = TRANS;
    },
    // 点击某点设置滑动条
    startPointHandler (e) {
      var left = e.pageX - this.offset - HALFWIDTH
      this._setDisByWidth(left)
    },
    // 减
    minusHandler (e) {
      const tYear = this.curYear - 1
      this.curYear = tYear >= 0 ? tYear : 0
    },
    // 加
    plusHandler (e) {
      const tYear = this.curYear + 1
      this.curYear = tYear <= this.maxIndex ? tYear : this.maxIndex
    },
    // 根据距离设置滑动条
    _setDisByWidth (width) {
      const nDis =
        width < 0 ? 0 : width > this.nSliderWidth ? this.nSliderWidth : width
      const curIndex = Math.round(nDis / this.nStep)
      if (curIndex != this.nCurIndex) {
        this.nCurIndex = Math.round(nDis / this.nStep)
        this.moveDis = (this.nCurIndex + 1) * this.nStep
        this.curYear = parseInt(this.nCurIndex)
        // parseInt(this.startYear) +
      }
    },
    // 根据年龄index设置滑动条
    _setDisByYear (year = this.curYear) {
      this.nCurIndex = year // - this.startYear;
      this.moveDis = this.nCurIndex * this.nStep
    },
    /* slider end */

    // 产品切换
    setHandler (index) {
      this.$emit('product-change', index)
    },
    // 类型切换
    typeHandler (index) {
      this.$emit('type-change', index)
    },
    partHandler (index) {
      if (!this.accountBtnsText.length) return
      this.$emit('part-change', index)
    },
    // 切换利率
    // setRateHandler() {
    //   let {
    //     curProduct: {
    //       rate: {
    //         value
    //       }
    //     },
    //     prdIndex
    //   } = this
    //   this.$emit('rate-change', value, prdIndex)
    // },
    // 切换分红
    // setBonusHandler() {
    //   let {
    //     curProduct: {
    //       bonus: {
    //         value
    //       }
    //     },
    //     prdIndex
    //   } = this
    //   this.$emit('bonus-change', value, prdIndex)
    // },
    // 格式化
    _format (data, unit) {
      let result = isNaN(data) ? '-' : Math.round(parseFloat(data))
      let moneyType = ''
      if (result !== '-') {
        moneyType = `<b>${unit || '元'}</b>`
      }
      result = `<span>${result}</span>${moneyType}`
      return result
    }
  }
}
</script>

<template>
  <article class="demonstration-wrap">
    <slot name="header">
      <h3 class="demonstration-title">
        保单利益
      </h3>
    </slot>

    <section v-if="curProduct" class="demonstration-container">
      <div
        v-if="products.list.length > 1"
        class="navigation"
        :class="{ 'after-bd-b': products.list.length <= 3 }"
      >
        <nav class="nav">
          <a
            v-for="(pd, index) in products.list"
            :key="index"
            href="javascript:;"
            class="item after-bd-b"
            :class="{ cur: products.value == pd.productId }"
            @click.stop="setHandler(index)"
          >{{ pd.productName }}</a>
        </nav>
      </div>
      <div
        v-if="curProduct.extraTitle && curProduct.extraTitle.length > 1"
        class="profit-data-plus"
      >
        <div class="inner">
          <a
            v-for="(item, index) in curProduct.extraTitle"
            :key="index"
            href="javascript:;"
            :class="{ cur: index === products.type }"
            @click.stop.prevent="typeHandler(index)"
          >{{ item }}</a>
        </div>
      </div>
      <div v-if="accountBtnsText.length" class="add-take-reduce">
        <div class="inner">
          <a
            v-for="(item, index) in accountBtnsText"
            :key="index"
            href="javascript:;"
            :class="{ cur: index === products.part }"
            @click.stop.prevent="partHandler(index)"
          >{{ item }}</a>
        </div>
      </div>
      <div class="condition">
        <div class="bonus-wrap">
          <span
            v-if="curProduct && curProduct.bonus && curProduct.rate"
          >选择</span>
          <span
            v-if="curProduct && curProduct.bonus && curProduct.rate"
            class="select"
          >
            <!-- @change.stop="setBonusHandler" -->
            <select v-model="curProduct.bonus.value" name="bonus" class="bonus">
              <option
                v-for="curPd in curProduct.bonus.opts"
                :key="curPd.value"
                :value="curPd.value"
              >
                {{ curPd.description }}
              </option>
            </select>
            <i class="iconfont icon-arrow_down" />
          </span>
          <span>保单利益如下：</span>
        </div>
        <div v-if="showAddAndTake" class="add-and-take">
          <div class="description1">
            灵活领取，满足人生各阶段保障需求
          </div>
          <div
            v-for="(item, index) in addAndTake[0].adjustData"
            :key="index"
            class="description2"
          >
            {{ item[0] + propProducts.startIndex + insuredAge }}岁
            <template v-if="item[0] !== item[1]">
              至{{ item[1] + propProducts.startIndex + insuredAge }}岁
            </template>
            领{{ item[2] }}元{{ item[3] }}
          </div>
        </div>
        <div
          v-if="curProduct && curProduct.bonus && !curProduct.rate"
          class="profit-condition bonus-wrap"
        >
          <span
            v-for="curPd in curProduct.bonus.opts"
            :key="curPd.value"
            class="profit-item"
          >
            <!-- @change.stop="setBonusHandler" -->
            <input
              v-model="curProduct.bonus.value"
              type="radio"
              name="bonus"
              :value="curPd.value"
            >
            <label class="profit-label after-bdr" for>
              <p class="profit-label-in" v-html="curPd.description" />
            </label>
          </span>
        </div>
        <div
          v-if="curProduct && curProduct.rate"
          class="profit-condition rate-wrap"
        >
          <span
            v-for="curPd in curProduct.rate.opts"
            :key="curPd.value"
            class="profit-item"
          >
            <!-- @change.stop="setRateHandler" -->
            <input
              v-model="curProduct.rate.value"
              type="radio"
              name="rate"
              :value="curPd.value"
            >
            <label for class="profit-label after-bdr">
              <template v-if="/\$/.test(curPd.description)">
                <p v-html="curPd.description.split('$')[0]" />
                <p v-html="curPd.description.split('$')[1]" />
              </template>
              <template v-else>
                <p v-html="`${(curPd.value * 100).toFixed(2)}%`" />
                <p v-html="curPd.description" />
              </template>
            </label>
          </span>
        </div>
      </div>

      <slot v-if="profitType" name="body" />
      <template v-if="profit && !profitType">
        <div class="explicit">
          <div class="explicit-inner after-bdr">
            <div class="explicit-table">
              <div class="hd">
                <div
                  v-if="profitList.length && profitLen"
                  key="age"
                  class="explicit-cond after-bdr"
                >
                  <div
                    class="explicit-cur"
                    v-html="
                      `保单年度<span>${
                        curYear + propProducts.startPolicyNo
                      }</span>年，被保人<span>${
                        insuredAge + propProducts.startIndex + curYear + 1
                      }</span>岁时`
                    "
                  />
                  <i class="iconfont icon-arrow_down" />
                  <select
                    v-model="curYear"
                    name="explicit-years"
                    class="explicit-years"
                  >
                    <option
                      v-for="(item, index) in profitLen"
                      :key="index"
                      :value="index"
                    >
                      {{
                        `保单年度${
                          index + propProducts.startPolicyNo
                        }年，被保人${
                          insuredAge + index + propProducts.startIndex + 1
                        }岁时`
                      }}
                    </option>
                  </select>
                </div>
                <div v-else key="age" class="no-data">
                  无数据
                </div>
              </div>
              <div v-if="profitList.length" class="bd">
                <dl
                  v-for="(curPt, index) in profitList"
                  :key="index"
                  class="item"
                >
                  <dt>
                    <i>{{ curPt.name }}：</i>
                  </dt>
                  <dd v-html="_format(curPt.values[curYear], curPt.unit)" />
                </dl>
              </div>
            </div>
          </div>
          <div class="explicit-arrow">
            <div class="arrow" :style="disStyle" />
          </div>
        </div>
        <div class="slider">
          <div
            class="slider-btn minus"
            @click.stop.prevent="minusHandler"
          />
          <div class="slider-btn plus" @click.stop.prevent="plusHandler" />
          <div class="runway-wrap">
            <div class="runway-inner" @click.stop.prevent="startPointHandler">
              <div ref="runway" class="runway">
                <div class="bar" :style="barStyle" />
                <div
                  class="button-wrap"
                  :style="disStyle"
                  @touchstart.prevent="startHandler"
                  @touchmove.prevent="moveHandler"
                  @touchend.prevent="endHandler"
                >
                  <div class="tooltip">
                    {{ insuredAge + curYear + propProducts.startIndex + 1 }}岁
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="slider-tips">
        <p>拖动按钮查看不同年龄段保单利益</p>
      </div>
      <slot name="footer" />
    </section>
    <div v-else class="loading" />
  </article>
</template>

<style lang="postcss">
@import 'variable.css';

.demonstration-wrap {
  width: 94.667%;
  margin: 0 auto 10px;
  border-radius: 6px;
  background-color: white;
  .demonstration-title {
    padding: 13px 15px;
    font-size: 17px;
    font-weight: bold;
    color: var(--primary-color-text);
    text-align: center;
  }
  .condition,
  .explicit {
    background-color: white;
  }
  .loading {
    width: 16px;
    height: 16px;
    @apply --center;
    background: url(//img.winbaoxian.com/static/images/n3/goodstart/Help/img-loading.gif)
      no-repeat center;
    background-size: 16px 16px;
  }
}

.demonstration-container {
  user-select: none;
  touch-callout: none;
  .profit-data-plus,
  .add-take-reduce {
    padding: 0.3rem 0.3rem 0;
    text-align: center;
    .inner {
      overflow-x: auto;
      width: 70%;
      margin: 0 auto;
      border-width: 1px;
      border-style: solid;
      font-size: 0;
      border-radius: 10rem;
      white-space: nowrap;
      &::-webkit-scrollbar {
        width: 0px;
        display: none;
      }
      a {
        display: inline-block;
        width: 50%;
        padding: 0.18rem 0.24rem;
        font-size: 0.3rem;
        text-decoration: none;
        border-radius: 10rem;
      }
    }
  }
  .explicit-arrow {
    position: relative;
    .arrow {
      z-index: 2;
      position: absolute;
      left: 38px;
      top: 0;
      &::before,
      &::after {
        content: '';
        display: block;
        border-width: 12px;
        position: absolute;
        left: 0;
        top: 0;
        text-align: center;
        border-style: solid dashed dashed;
        font-size: 0;
        line-height: 0;
      }
      &::before {
        border-color: var(--theme-primary-color) transparent transparent;
      }
      &::after {
        top: -1px;
        border-color: white transparent transparent;
      }
    }
  }
  .explicit {
    margin: 0 auto;
    padding: 0 14px;
    width: 99.5%;
  }
  .explicit-inner {
    padding: 7.6%;
    &::after {
      border-radius: 0.24rem;
      border-color: var(--theme-primary-color);
    }
  }
  .explicit-table {
    font-size: 0.32rem;
    color: #333;
    .hd {
      margin-bottom: 0.3rem;
      text-align: center;
      .no-data {
        color: var(--patch-color-text);
        font-size: 0.24rem;
      }
    }
    .explicit-cond {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 0.54rem;
      margin: 0 auto;
      padding: 0.1rem 0.3rem 0.1rem 0.4rem;
      border-radius: 0.12rem;
      color: var(--primary-color-text);
      font-size: 0.3rem;
      text-align: center;
      -webkit-tap-highlight-color: transparent;
      &::after {
        border-radius: 0.24rem;
      }
    }
    .icon-arrow_down {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 12px;
      margin-top: -1px;
      color: var(--theme-primary-color);
    }
    .explicit-cur {
      margin-right: 0.4rem;
      line-height: 0.34rem;
      height: 100%;
      @apply --text-ellipsis;
      span {
        margin: 0 2px;
        color: var(--theme-primary-color);
      }
    }
    .explicit-years {
      z-index: 1;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      color: transparent;
      border: 0;
      vertical-align: middle;
      appearance: none;
      background: transparent;
    }
    .item {
      display: flex;
      height: 0.48rem;
      line-height: 0.48rem;
      margin-bottom: 0.2rem;
      &:last-child {
        margin-bottom: 0;
      }
      dt,
      dd {
        flex: 1;
        font-size: 0.28rem;
        height: 0.48rem;
        width: 50%;
      }
      dt {
        position: relative;
        text-align: right;
        line-height: 0.52rem;
      }
      dd {
        text-align: left;
        @apply --text-ellipsis;
        line-height: 0.44rem;
      }
      span {
        font-size: 0.36rem;
        vertical-align: middle;
        color: var(--theme-primary-color);
      }
      b {
        vertical-align: middle;
      }
      i {
        z-index: 10;
        position: absolute;
        right: 0;
        top: 50%;
        line-height: 1;
        transform: translateY(-50%);
        @apply --text-ellipsis;
      }
    }
  }
  .slider {
    position: relative;
    width: 100%;
    padding: 10px 0;
    .slider-btn {
      z-index: 20;
      position: absolute;
      top: 50%;
      width: 44px;
      height: 44px;
      font-size: 32px;
      line-height: 40px;
      text-align: center;
      transform: translateY(-50%);
      -webkit-tap-highlight-color: transparent;
      color: var(--theme-primary-color);
      &::after {
        content: '';
        @apply --center;
        height: 2px;
        width: 18px;
        background-color: var(--theme-primary-color);
      }
    }
    .minus {
      left: 5px;
    }
    .plus {
      right: 5px;
      &::before {
        content: '';
        @apply --center;
        width: 2px;
        height: 18px;
        background-color: var(--theme-primary-color);
      }
    }
    .runway-wrap {
      padding: 15px 65px;
    }
    .runway-inner {
      padding: 5px 0;
    }
    .runway {
      width: 100%;
      height: 8px;
      margin: 0 auto;
      border-radius: 100px;
      position: relative;
      cursor: pointer;
      vertical-align: middle;
      background-color: #e0e0e0;
    }
    .bar {
      position: absolute;
      height: 8px;
      width: 0;
      max-width: 100%;
      border-radius: 100px;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
    }
    .button-wrap {
      width: 50px !important;
      height: 28px !important;
      position: absolute;
      z-index: 21;
      top: 50%;
      border-width: 2px !important;
      border-style: solid;
      border-color: var(--theme-primary-bg);
      border-radius: 100px;
      margin-left: -25px !important;
      margin-top: -14px !important;
      background-color: transparent;
      text-align: center;
      user-select: none;
      &::before {
        z-index: 21;
        content: '';
        position: absolute;
        top: -10px;
        left: -10px;
        right: -10px;
        bottom: -10px;
      }
    }
    .tooltip {
      width: 100%;
      height: 100%;
      font-size: 12px;
      color: #fff;
      line-height: 24px;
      border-radius: 100px;
      user-select: none;
      background-color: var(--theme-primary-color);
    }
  }
  .slider-tips {
    text-align: center;
    color: var(--patch-color-text);
    font-size: 12px;
    padding-bottom: 20px;
  }
}

.add-and-take {
  padding: 0 20px 15px 30px;
}
</style>
